export default __webpack_public_path__ + "static/media/header-LSP-new-2.f5c55aa3.gif";